export default __webpack_public_path__ + "static/12-190a27124815f878e56c448d3c42cc81.png";